// IndexedDB-backed local cache for portal state.
// Pattern: write-locally-first, sync-to-server-in-background.
// Server is authoritative; last-write-wins on conflict.

import { openDB } from "idb";

const DB_NAME = "tca-local";
const DB_VERSION = 1;
const STORE = "portal";
const KEY = "state";

async function db() {
    return openDB(DB_NAME, DB_VERSION, {
        upgrade(d) {
            if (!d.objectStoreNames.contains(STORE)) {
                d.createObjectStore(STORE);
            }
        },
    });
}

export async function readLocalState() {
    try {
        const d = await db();
        return (await d.get(STORE, KEY)) || null;
    } catch {
        return null;
    }
}

export async function writeLocalState(state) {
    try {
        const d = await db();
        await d.put(STORE, { ...state, _saved_at: new Date().toISOString() }, KEY);
    } catch {
        // best-effort; IndexedDB may be unavailable (private mode, etc.)
    }
}

export async function clearLocalState() {
    try {
        const d = await db();
        await d.delete(STORE, KEY);
    } catch {
        /* noop */
    }
}

// Online/offline pulse
export function watchOnline(handler) {
    const fn = () => handler({ online: navigator.onLine, at: new Date().toISOString() });
    window.addEventListener("online", fn);
    window.addEventListener("offline", fn);
    fn();
    return () => {
        window.removeEventListener("online", fn);
        window.removeEventListener("offline", fn);
    };
}
